import Vue from 'vue';

/**
 *  数値の桁を丸める
 * @param value 数値
 * @param decimal 小数点以下の桁数
 */
Vue.filter('fixDecimal', function (value: number | string, decimal: number = 1) {
  if (!value) return '';

  if (typeof value === 'string') {
    // 文字列が数値でない場合はそのまま返す
    if (isNaN(parseFloat(value))) return value;
    value = parseFloat(value);
  }

  return value.toFixed(decimal);
});